module.exports = __webpack_public_path__ + "img/icon-custom-remove-dark.2b89db17.svg";